import React from 'react';

const SkillsTextSection = ({ data, sectionKey, title, customHeading, itemRenderer }) => {
  const section = data[sectionKey];

  if (!section || !section.enable || section.items.filter(x => x.enable).length === 0) {
    return null;
  }

  const defaultItemRenderer = (item) => item.key;
  const renderItem = itemRenderer || defaultItemRenderer;

  return (
    <div>
      <div className="mb-1 mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
        {customHeading || title}
      </div>
      <div className="text-sm">
        {section.items.filter(x => x.enable).map(renderItem).join(', ')}
      </div>
    </div>
  );
};

export default SkillsTextSection; 